import { render } from "./ServicesTable.vue?vue&type=template&id=11f84946&ts=true"
import script from "./ServicesTable.vue?vue&type=script&lang=ts"
export * from "./ServicesTable.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__